import { NavLink } from 'react-router-dom';
import { Container, cx } from './ui';

/**
 * The documentation section's own navigation.
 *
 * The header carries one "Documentation" entry, and the docs are several pages
 * rather than one. Without this, a reader who lands on Security & Compliance
 * from a search result has no way back to getting-started, and a reader on
 * getting-started has no way to discover the other references at all.
 *
 * Rendered as a sticky strip under the header rather than as a sidebar: a
 * handful of items do not justify a column, and a sidebar would collapse to a
 * hamburger on the widths where the control tables are already competing for
 * space.
 */

const PAGES = [
  { to: '/docs', label: 'Getting started', end: true },
  { to: '/docs/commands', label: 'Command reference', end: false },
  { to: '/docs/security-compliance', label: 'Security & Compliance', end: false },
] as const;

export function DocsNav() {
  return (
    <div className="sticky top-16 z-30 border-b border-hull-800 bg-hull-950/85 backdrop-blur">
      <Container>
        <nav aria-label="Documentation">
          <ul className="flex gap-1 overflow-x-auto py-2">
            {PAGES.map((page) => (
              <li key={page.to}>
                <NavLink
                  to={page.to}
                  end={page.end}
                  className={({ isActive }) =>
                    cx(
                      'block whitespace-nowrap rounded-lg px-3 py-1.5 text-sm transition',
                      'focus-visible:outline focus-visible:outline-2',
                      'focus-visible:outline-offset-2 focus-visible:outline-surge-400',
                      isActive
                        ? 'bg-hull-800 font-medium text-white'
                        : 'text-hull-300 hover:text-white',
                    )
                  }
                >
                  {page.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </Container>
    </div>
  );
}
